import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HandleError = error => {
    toast.configure();
    console.log("HandleError", error)
    if (error?.status_code === 403) {
        localStorage.removeItem("security_auth");
        toast.error(error.message)
        setTimeout(() => {
            window.location.href = "/"
        }, 700);
    }
};

export default HandleError;